import { connect } from 'react-redux'
import { addToCart, removeFromCart, deleteServiceFromCart } from '../../actions'
import { BASE_URL } from '../../variables'
import AddToCartButton from '../Services/Components/ServiceList/AddToCartButton'
import dustBin from '../../images/dustbin.svg'
const CartTable = ({ cart, cartDetail, addToCart, removeFromCart, deleteServiceFromCart }) => {


    const addToCartHandler = (service_id, setCartCount) => {
        addToCart(service_id, cartDetail.category, setCartCount)
    }
    const removeFromCartHandler = (service_id) => {
        removeFromCart(service_id)
    }
    const deleteService = (service_id) => {
        deleteServiceFromCart(service_id)
    }
    const rendertableRow = Object.values(cart).map(x => {
        
        return (
            <div className={`cart-table-row ${x?.added ? "added" : ""}`} key={x.service.id}>
                <div className="cart-item-image"><img src={BASE_URL + x.service.icon} alt={x.service.name} width={50}/></div>
                <div className="cart-item-content">
                    <div className="cart-item-header">{x.service.name}</div>
                    <div className="cart-item-price">Rs. {x.service.price}</div>
                    <div className="cart-item-action">
                        <div className="cart-item-quantity"><AddToCartButton forService={x.service} add={addToCartHandler} remove={removeFromCartHandler} cart={cart}/></div>
                        <div className="cart-item-remove" onClick={() => deleteService(x.service.id)}>
                            <img src={dustBin} alt="delete" />
                            <span>Remove</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    })
    return (
        <div className="cart-table-container">
            {rendertableRow.length > 0 ? rendertableRow : <div className="empty-cart"><h2>Empty Cart</h2></div>}
        </div>
    )
}

export default connect(null , { addToCart, removeFromCart, deleteServiceFromCart })(CartTable);

/*
        <table className="ui celled padded table">
            <thead>
                <tr>
                    <th className="single line">Product</th>
                    <th className="single line">Price</th>
                    <th className="single line">Item Total</th>
                    <th className="single line">Remove</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="">
                        <h2 className="ui center aligned header">Product 1</h2>
                    </td>
                    <td>
                        <div className="item-price">Rs 500</div>
                    </td>
                    <td>
                        <div className="item-total">Rs 1000</div>
                    </td>
                    <td>
                        <div className="ui star rating" data-rating="3s" data-max-rating="3"></div>
                    </td>
                </tr>
            </tbody>
        </table>
*/